import React from 'react';
import { Logo } from '@/assets/logo';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export function RegisterSuccess() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-sm p-8 max-w-md w-full text-center">
        <Logo className="h-24 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-primary-dark mb-4">
          تم تقديم طلب التسجيل بنجاح
        </h1>
        <p className="text-gray-600 mb-8">
          سيتم معالجة الطلب قريبا
        </p>
        {/* <p className="text-gray-600 mb-6">
          سيتم التواصل معك عند الموافقة على طلبك
        </p> */}
        <Button
          onClick={() => navigate('/')}
          className="hover:bg-secondary"
        >
          العودة للصفحة الرئيسية
        </Button>
      </div>
    </div>
  );
}